import {OutlinedInput} from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'

import useToolbarStyles, {
  useOutlinedInputStyles,
} from 'components/Table/useTableToolbarStyles'
import {getQueryFromUrl} from 'helpers/commonHelper'
import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useLocation} from 'react-router-dom'

export const SEARCH_SELECT_ITEMS = [
  {label: 'ICustomerOrganizationName', value: 'orgName'},
  {label: 'IProductNameSelect', value: 'goodsName'},
  {label: 'IOrderNo', value: 'paymentNo'},
]

interface SelectAnalysisSearchProps {
  onSearch: (key: string, value: string) => void
}

export default function ToolbarSearch({onSearch}: SelectAnalysisSearchProps) {
  const location = useLocation()
  const classes = useToolbarStyles()
  const outlinedInputClasses = useOutlinedInputStyles()

  const {t} = useTranslation()

  const [searchCondition, setSearchCondition] = useState('goodsName')
  const [searchKeyword, setSearchKeyword] = useState('')

  const handleSearchChanged = (event: React.ChangeEvent<{value: unknown}>) => {
    setSearchCondition(event.target.value as string)
    setSearchKeyword('')
  }

  useEffect(() => {
    const searchParams = getQueryFromUrl(location.search)
    SEARCH_SELECT_ITEMS.forEach((item) => {
      if (item.value in searchParams) {
        setSearchCondition(item.value)
        setSearchKeyword(searchParams[item.value])
      }
    })
  }, [])

  return (
    <div className={classes.container}>
      <FormControl variant='outlined'>
        <Select
          value={searchCondition}
          onChange={handleSearchChanged}
          className={classes.searchSelect}
          input={
            <OutlinedInput
              name='age'
              id='outlined-age-simple'
              classes={outlinedInputClasses}
            />
          }
        >
          {SEARCH_SELECT_ITEMS.map((item) => (
            <MenuItem value={item.value} key={item.value}>
              {t(item.label)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <div className={classes.searchWrap}>
        <input
          placeholder={t('ISearch')}
          className={classes.searchInput}
          value={searchKeyword}
          type={searchCondition === 'paymentNo' ? 'number' : 'text'}
          onChange={(event) => {
            const value = String(event?.currentTarget?.value)
            setSearchKeyword(value)
          }}
        />
        <span className={classes.searchDivider} />
        <button
          type='submit'
          onClick={() => {
            onSearch(searchCondition, searchKeyword)
          }}
          className={classes.searchButton}
        >
          {t('ISearch')}
        </button>
      </div>
    </div>
  )
}
